import React from 'react';
import { FormGroup, Label, Button } from 'reactstrap'

const ButtonType3 = (props) => {
    return (
        <>
            {
                props.disabled ? 
                <div className={props.disabledClassName}>
                    {props.btnName}
                </div>
                :
                <div className={`${props.className}`} onClick={() => props.onClick()}>
                    {props.btnName}
                </div>
            }
        </>
        
    )
}

export default ButtonType3;